// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let GeocodingQuery = require("../propertyForms/Geocoding/GeocodingQuery.bs.js");
let MlsStatusQuery = require("../propertyForms/Geocoding/MlsStatusQuery.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let PropertyWizardFormRelayEffects_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_formState_graphql.bs.js");
let PropertyWizardFormRelayEffects_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_localDraft_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayEffects_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

let LocalDraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_decode;

let LocalDraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let LocalDraftFragment = {
  localDraftPropertyType_decode: LocalDraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayEffects_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function use$2(draft, formState, setDuplicatedProperty) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let match$1 = PropertyWizardRelayUtils.QueryParams.use();
  let setQueryParams = match$1[1];
  let queryParams = match$1[0];
  let geocodingTriggeredAt = React.useRef(Date.now());
  let mlsStatusTriggeredAt = React.useRef(Date.now());
  let doMlsStatusCheck = PropertyWizardRelayUtils.useMlsStatusCheck();
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, formState);
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let selectedAreaId = Stdlib_Option.map(draft$1.draftProperty.selectedArea, area => area.id);
  React.useEffect(() => {
    let run = async () => {
      let match = formState$1.geocodingStatus;
      let match$1 = draft$1.draftProperty.addressToGeocode;
      if (match === "Called") {
        return;
      }
      if (selectedAreaId === undefined) {
        return;
      }
      if (match$1 === undefined) {
        return;
      }
      if (match$1.trim() === "") {
        return;
      }
      let triggeredAt = Date.now();
      geocodingTriggeredAt.current = triggeredAt;
      let match$2 = draft$1.draftProperty.propertyType;
      let clientType;
      clientType = match$2 === "FOR_SALE" ? "SELLER" : "LANDLORD";
      updateFormState(formState => {
        formState.geocodingStatus = "Called";
      });
      let tmp;
      if (typeof mode !== "object") {
        tmp = undefined;
      } else {
        switch (mode.TAG) {
          case "Edit" :
            tmp = mode.id;
            break;
          case "Rebroadcast" :
          case "BroadcastQuietSeller" :
            tmp = mode._0;
            break;
        }
      }
      let res = await Utils__Promise.toJsPromise(GeocodingQuery.queryFn(match$1, selectedAreaId, clientType, tmp));
      if (triggeredAt !== geocodingTriggeredAt.current) {
        return;
      }
      setDuplicatedProperty(param => {
        if (typeof res === "object" && res.NAME === "DuplicatePropertyError") {
          return Primitive_option.some(res.VAL.fragmentRefs);
        }
      });
      let variant = res.NAME;
      if (variant !== "PropertyAddressValidated") {
        if (variant === "GeocodingError") {
          if (res.VAL === "OutsideChapterBoundaries") {
            updateDraftProperty(localDraftProperty => {
              let newrecord = {...localDraftProperty};
              newrecord.geocodingData = undefined;
              return newrecord;
            });
            return updateFormState(formState => {
              formState.geocodingStatus = "ErrorOutsideChapterBoundaries";
            });
          } else {
            updateDraftProperty(localDraftProperty => {
              let newrecord = {...localDraftProperty};
              newrecord.geocodingData = undefined;
              return newrecord;
            });
            return updateFormState(formState => {
              formState.geocodingStatus = "Error";
            });
          }
        } else {
          updateDraftProperty(localDraftProperty => {
            let newrecord = {...localDraftProperty};
            newrecord.geocodingData = undefined;
            return newrecord;
          });
          return updateFormState(formState => {
            formState.geocodingStatus = "ErrorDuplicateListing";
          });
        }
      }
      let match$3 = res.VAL;
      let standardizedAddress = match$3.standardizedAddress;
      let coordinates = match$3.coordinates;
      let displayNeighborhoods = match$3.displayNeighborhoods;
      updateDraftProperty(localDraftProperty => {
        let newrecord = {...localDraftProperty};
        newrecord.geocodingData = coordinates !== undefined && standardizedAddress !== undefined ? ({
            lat: coordinates.lat,
            lon: coordinates.lon,
            standardizedAddress: standardizedAddress.address,
            standardizedCity: standardizedAddress.city,
            standardizedState: standardizedAddress.state,
            standardizedZip: standardizedAddress.zip
          }) : undefined;
        return newrecord;
      });
      return updateFormState(formState => {
        PropertyWizardFormRelay.FormState.setDisplayNeighborhoods(formState, displayNeighborhoods.map(dn => ({
          __id: dn.__id,
          __typename: dn.__typename
        })));
        formState.geocodingStatus = "Valid";
      });
    };
    run();
  }, [
    draft$1.draftProperty.addressToGeocode,
    selectedAreaId,
    mode,
    draft$1.draftProperty.propertyType
  ]);
  React.useEffect(() => {
    if (doMlsStatusCheck) {
      let run = async () => {
        let match = formState$1.mlsStatus;
        let match$1 = draft$1.draftProperty.addressToGeocode;
        if (match === "Called") {
          return;
        }
        if (selectedAreaId === undefined) {
          return;
        }
        if (match$1 === undefined) {
          return;
        }
        if (match$1.trim() === "") {
          return;
        }
        let triggeredAt = Date.now();
        mlsStatusTriggeredAt.current = triggeredAt;
        updateFormState(formState => {
          formState.mlsStatus = "Called";
        });
        let res = await MlsStatusQuery.queryFn(match$1, selectedAreaId);
        if (triggeredAt !== mlsStatusTriggeredAt.current) {
          return;
        }
        if (res.TAG !== "Ok") {
          return updateFormState(formState => {
            formState.mlsStatus = "Error";
          });
        }
        let mlsStatus;
        switch (res._0.__typename) {
          case "PropertyMlsStatusNotOnMls" :
            mlsStatus = "NotOnMls";
            break;
          case "PropertyMlsStatusOnMls" :
            mlsStatus = "OnMls";
            break;
          case "PropertyMlsStatusOnMlsButAllowed" :
            mlsStatus = "OnMlsButAllowed";
            break;
          case "__unselected" :
            mlsStatus = "Error";
            break;
        }
        return updateFormState(formState => {
          formState.mlsStatus = mlsStatus;
        });
      };
      run();
    } else {
      updateFormState(formState => {
        formState.mlsStatus = "NotOnMls";
      });
    }
  }, [
    draft$1.draftProperty.addressToGeocode,
    selectedAreaId,
    mode,
    draft$1.draftProperty.propertyType,
    doMlsStatusCheck
  ]);
  React.useEffect(() => {
    let match = queryParams.draftId;
    let match$1 = draft$1.serverDraftId;
    if (match !== undefined) {
      if (match$1 !== undefined) {
        if (match !== match$1) {
          setQueryParams("replaceIn", {
            draftId: match$1
          });
        }
      } else {
        setQueryParams("replaceIn", {
          draftId: undefined
        });
      }
    } else if (match$1 !== undefined) {
      setQueryParams("replaceIn", {
        draftId: match$1
      });
    }
  }, [
    queryParams.draftId,
    draft$1.serverDraftId
  ]);
  let router = Next.useRouter();
  React.useEffect(() => {
    Next.Router.prefetch("/my_clients/[id]", router);
  }, []);
}

let QueryParams;

let Form;

let Validators;

let KeyFactsValidators;

exports.QueryParams = QueryParams;
exports.Form = Form;
exports.LocalDraftFragment = LocalDraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Validators = Validators;
exports.KeyFactsValidators = KeyFactsValidators;
exports.use = use$2;
/* Next Not a pure module */
